import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { reloadOnceForStaleChunk } from './lib/chunkReload';

// Every route is React.lazy()-loaded (see App.tsx), so a deploy that renames
// chunk files leaves any tab still open on the old index.html unable to
// fetch a chunk it hasn't loaded yet - Vite fires this event when that
// dynamic import 404s. See chunkReload.ts for the shared reload-once guard.
window.addEventListener('vite:preloadError', () => {
  reloadOnceForStaleChunk();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
